import type { Notificacion } from "../services/notificaciones-service";
import type { EstadoLienzo } from "./lienzo";

/**
 * Avisos rápidos en el lienzo (antes de publicar). La validación completa —variables contra el
 * catálogo, formatos, condiciones— la hace el backend y llega en `erroresDelBorrador`.
 */
export function avisosDeNotificacion(n: Notificacion, estado: EstadoLienzo): string[] {
  const avisos: string[] = [];
  if (!estado.conexiones.some((c) => c.notificacionClave === n.clave)) avisos.push("No está conectada a ningún evento");
  if (!n.nombre.trim()) avisos.push("Falta el nombre");
  switch (n.canal) {
    case "Email":
      if (n.destinatarios.length === 0) avisos.push("Sin destinatarios");
      if (!n.asunto?.trim()) avisos.push("Falta el asunto");
      if (!n.cuerpoHtml?.trim()) avisos.push("Falta el cuerpo");
      break;
    case "Campana":
      if (n.destinatarios.length === 0) avisos.push("Sin destinatarios");
      if (!n.titulo?.trim()) avisos.push("Falta el título");
      if (!n.texto?.trim()) avisos.push("Falta el texto");
      break;
    case "WebPush":
      if (n.destinatarios.length === 0) avisos.push("Sin destinatarios");
      if (!n.titulo?.trim()) avisos.push("Falta el título");
      if (!n.cuerpo?.trim()) avisos.push("Falta el cuerpo");
      break;
    case "Sms":
    case "Telegram":
      if (n.destinatarios.length === 0) avisos.push("Sin destinatarios");
      if (!n.texto?.trim()) avisos.push("Falta el texto");
      break;
    case "WhatsApp":
      if (n.destinatarios.length === 0) avisos.push("Sin destinatarios");
      if (!/^HX[0-9a-fA-F]{32}$/.test(n.contentSid ?? "")) avisos.push("Content SID inválido");
      break;
    case "Webhook":
      if (!/^https?:\/\/.+/.test(n.url ?? "")) avisos.push("URL inválida");
      if (!n.cuerpoJson?.trim()) avisos.push("Falta el cuerpo JSON");
      break;
  }
  return avisos;
}
